var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkOutlineSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 66C8 64.9391 8.42143 63.9217 9.17157 63.1716C9.92172 62.4214 10.9391 62 12 62H24V48L48 32L72 48V62H84C85.0609 62 86.0783 62.4214 86.8284 63.1716C87.5786 63.9217 88 64.9391 88 66V84C88 85.0609 87.5786 86.0783 86.8284 86.8284C86.0783 87.5786 85.0609 88 84 88H8V66Z",
    stroke: "#BC273C",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 12V32",
    stroke: "#BC273C",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 87.9997V61.9997H40V87.9997M36 87.9997H60M72 23.9997V11.9997C72 11.9997 69 17.9997 60 11.9997C51 5.99967 48 11.9997 48 11.9997V23.9997C48 23.9997 51 17.9997 60 23.9997C69 29.9997 72 23.9997 72 23.9997Z",
    stroke: "#BC273C",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineSchool);
export default __webpack_public_path__ + "static/media/icon-park-outline_school.ae55f9b4e0478e72ddbadb8a9835ff4b.svg";
export { ForwardRef as ReactComponent };